import Axios, { AxiosRequestConfig } from 'axios';
import {
  URL_BACKEND_ROOT
} from "../app/AppConst";
import { BrandEntity } from '../dto/brand/BrandEntity';
import { BrandModel } from '../dto/brand/BrandModel';
import { BrandSearch } from '../dto/brand/BrandSearch';
import { BaseResponse } from '../dto/response/BaseResponse';
import { ReadResponse } from '../dto/response/ReadResponse';
import { ApiClient } from '../util/ApiUtility';
import { BrandDetailEntity } from '../dto/brand/BrandDetailEntity';
import { BrandMediaEntity } from '../dto/brand/BrandMediaEntity';
import { BrandAttributeChoiceEntity } from '../dto/brand/BrandAttributeChoiceEntity';
import { AttributeChoiceEntity } from '../dto/attribute/AttributeChoiceEntity';

export const onBrandDetail = async (brandId: number) => {
  const requestConfig: AxiosRequestConfig = {
      headers: {
      'Content-Type': 'application/json',
      },
      method: 'GET',
      url: `${URL_BACKEND_ROOT}` + '/v1/cms/brand/' + brandId
  }
  const response = await ApiClient().request<BaseResponse<BrandDetailEntity>>(requestConfig);

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error("Амжилтгүй");
  }
}

export const onBrandSubmit = async (formData: FormData) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    method: 'POST',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/brand/init',
    data: formData
  }

  let response = await ApiClient().request<BaseResponse<BrandEntity>>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
      console.log(response);
  } else {
      throw new Error("Амжилтгүй");
  }
  return response.data;
}

export const onBrandMediaUpload = async (formData: FormData) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    method: 'POST',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/brand/media/init',
    data: formData
  }

  let response = await ApiClient().request<BaseResponse<BrandMediaEntity>>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
      return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}

export const onBrandMediaDelete = async (media: BrandMediaEntity) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    method: 'GET',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/brand/media/delete/' + media.id,
    data: media
  }

  let response = await ApiClient().request<BaseResponse<any>>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
      return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}

export const onBrandAttributeCreate = async (brandAttributeChoice: BrandAttributeChoiceEntity) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/brand/link-attribute',
    data: brandAttributeChoice
  }
  const response = await ApiClient().request<BaseResponse<any>>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}

export const onBrandSearch = async (data: BrandSearch) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/brand',
    params: {
      name: data.name,
      offset: data.offset,
      limit: data.limit
    }
  }
  const response = await ApiClient().request<ReadResponse>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}

export const onBrand = async (brandId: string) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/brand',
    params: {
      id: brandId
    }
  }
  const brandResponse = await ApiClient().request<ReadResponse>(requestConfig);
  if (brandResponse.status >= 200 && brandResponse.status < 300) {
    return brandResponse.data;
  } else {
    throw new Error("Амжилтгүй");
  }
}

export const onAddAttributeChoiceToBrand = async(data: BrandModel) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'PUT',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/brand',
    data: data
  }
  const response = await ApiClient().request<BaseResponse<BrandEntity>>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}

export const onRemoveAttributeChoiceFromBrand = async (brandAttributeChoice: BrandAttributeChoiceEntity) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/brand/remove-attribute-choice',
    data: brandAttributeChoice
  }
  const response = await ApiClient().request<BaseResponse<any>>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}

export const onBrandBasicUpdate = async (brand: BrandEntity) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/brand/update',
    data: brand
  }

  let response = await ApiClient().request<BaseResponse<BrandEntity>>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
      return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}

export const onBrandDelete = async (brandId: number) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'DELETE',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/brand/' + brandId
  }
  const response = await ApiClient().request<BaseResponse<any>>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}